<template>
    <div class="ly-dialog-button" v-if="isDisplay">
        <Button :icon="attrs.icon" @click="setModalShow(true)" ref="dialogButton">
           {{attrs.header || attrs.title}}
        </Button>
        <Modal
            v-model="modalShow"
            scrollable
            :title="attrs.title"
            :styles="{marginLeft: modalLeft}"
            :width="attrs.width||520"
            ref="dialogModal">
        　　<Card class="ly-form" :bordered="false" v-if="modalShow" :dis-hover="true">
                <Alert type="warning" v-if="tips.length > 0">{{tips}}</Alert>
                <Row>
                    <Form ref="lyForm" :model="bindForm" :rules="formRules" :label-width="labelWidth" @keydown.native.enter.prevent="keyDownEvent">
                        <Col v-for="(el, i) in attrs.children" :key="i" :span="el.span ? el.span : '8'">
                            <FormItem :label="el.title" :prop="el.field">
                                <ly-hoc :attrs="el" v-model="bindForm[el.field]" :page-data="page" :is-show="modalShow" :form-data="bindForm"></ly-hoc>
                            </FormItem>
                        </Col>
                    </Form>
                </Row>
            </Card>
            <div slot="footer">               
                <Button type="primary" @click="handleModalOK" :loading="loading" :disabled="!canSubmit">{{ attrs.submitName || '确定'}}</Button>
                <Button type="error" v-if="attrs.isDel" @click="handleDelete" :loading="loading" :disabled="!canSubmit">删除</Button>
                <Button type="default" @click="setModalShow(false)">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    /**
     * 具有弹窗功能的按钮操作
     *
     * 获取用户信息vuex
     * 2021-9-21 modify by wxf
     *
     * 第二次点击弹窗数据清空 在modal上加了条v-if语句强制重新加载 2020-09-23 by wxf
     *
     * 增加idname，通过index方式上传id
     * 2021-7-22 modify by wxf
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    import FormMixin from '@/utils/form.mixin'
    import ExportMixin from '@/utils/export.mixin'
    import {mapGetters} from 'Vuex'
    export default {
        name: 'LyDialogButton',
        mixins: [CompEventMixin, CompDisplayMixin, FormMixin, ExportMixin],
        props: {
            value: {
                type: [Object, Boolean],
                default: _ => new Object()
            },
            row: {
                type: Object,
                default: _ => new Object()
            }, // 提供给tabel，用于绑定行数据
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        computed: {
            ...mapGetters(['userInfo']),
            /**
             * 标识，是否可以提交。
             * 这里特殊判断，当字段只有一个的时候，且值为空，就控制不显示
             2019-06-20 zjs添加
             */
            canSubmit () {
                let bool = true
                let arr = []
                for (let k in this.bindForm) {
                    if(k != ''){
                        arr.push(k)
                    }
                }
                if (arr.length == 1) {
                    bool = (this.bindForm[arr[0]] || this.bindForm[arr[0]] === 0) && String(this.bindForm[arr[0]]).length > 0
                }
                return bool
            }
        },
        data () {
            return {
                loading: false,
                modalShow: false,
                tips: '', // 弹窗的提示文字
                isInit: false, // 标识是否初始化
                modalLeft: 'auto', // 弹窗左侧的距离
                interval: '',
                keydownTimer: 0,
                keydownFunc: (e) => {
                    if (e.keyCode == 13 && this.canSubmit) {
                        let now = new Date().getTime()
                        if (now - this.keydownTimer > 800) {
                            this.keydownTimer = now
                            this.handleModalOK()
                        }
                    }
                }
            }
        },
        created () {
            if (this.row.hasOwnProperty('id')) {
                // row中有数据，就传给page
                this.page = this.row
            }
        },
        methods: {
            /**
             * 初始化拉取数据
             */
            initQueryData () {
                // if (this.isInit) return
                // 初始化TIPS
                if (this.attrs.tips && this.attrs.tips.length > 0) {
                    this.tips = this.templateString(this.attrs.tips, this.row.hasOwnProperty('id') ? this.row : this.page)
                }
                if (this.attrs.isSearch) {
                    let url = this.attrs.api
                    let path = null // url路径
                    // 有rowData字段说明是表格中传递过来的
                    if (this.row.hasOwnProperty('id')) {
                        path = this.$path.getPath(url, this.row, 'GET')
                        // }
                    } else { // 从路由中拿到参数
                        path = this.$path.getPath(url, this.$route.params, 'GET')
                    }
                    path = this.getUrlAndParams(path)
                    url = path.url
                    /**
                     * 返回的数据
                     * data: {
                     *      form: {
                     *          taocan: []
                     *      }
                     * }
                     */
                    this.$api.query(url).then((rs) => {
                        if (rs.form) {
                            for (let key in rs.form) {
                                this.setFieldValue(key, rs.form[key])
                            }
                        }
                    })
                }
                //
                // this.isInit = true
            },
            setModalShow (bool) {
                if (this.attrs.isEnter) {
                    if (bool) {
                        window.addEventListener('keydown', this.keydownFunc)
                    } else {
                        window.removeEventListener('keydown', this.keydownFunc)
                    }
                }
                // 是否跟随按钮显示
                if (this.attrs.isFollow) {
                    let modalLeft = this.$refs.dialogButton.$el.offsetLeft + 320
                    let bodyWidth = document.body.clientWidth
                    // 是否超过屏幕宽度，600是modal的宽度，这里默认
                    if ((modalLeft + 600) > bodyWidth) {
                        this.modalLeft = bodyWidth - 600 + 'px'
                    } else {
                        this.modalLeft = modalLeft + 'px'
                    }
                }
                this.loading = false
                this.modalShow = bool
                if (this.attrs.isModel) { // 作为普通组件进行绑定
                    this.initForm(this.value)
                } else {
                    // 有rowData字段说明是表格中传递过来的
                    this.initForm(this.row.hasOwnProperty('id') ? this.row : this.page)
                }
                // 初始化
                if (bool) {
                    this.initQueryData()
                }
            },
            /**
             * 确认的点击
             */
            handleModalOK () {
                if (this.$refs['lyForm']) {
                    if(this.attrs.isPureDisplay) { // 纯展示，不操作
                        this.setModalShow(false)
                    }
                    this.$refs['lyForm'].validate((valid) => {
                        if (!valid) {
                            this.$Message.error('请将信息填写完整!');
                        } else {
                            this.loading = true
                            let url = this.attrs.api
                            let path = null // url路径
                            // 有rowData字段说明是表格中传递过来的
                            if (this.row.hasOwnProperty('id')) {
                                path = this.$path.getPath(url, this.row, this.attrs.method)
                            } else if (this.page.hasOwnProperty('id')) {
                                path = this.$path.getPath(url, this.page, this.attrs.method)
                            } else { // 从路由中拿到参数
                                path = this.$path.getPath(url, this.$route.params, this.attrs.method)
                            }

                            path = this.getUrlAndParams(path)
                            url = path.url
                            // 判断是否是列表多选项数据
                            if (this.tableSelectLists && this.tableSelectLists.length > 0) {
                                this.bindForm['tableSelectLists'] = this.tableSelectLists
                            }
                            Object.assign(this.bindForm, path.params)
                            // 是否是导出功能
                            if (this.attrs.isExport) {
                                this.exportHttp(url, this.bindForm)
                            } else if (this.attrs.isModel) { // 作为普通组件进行绑定
                                this.$emit('input', Object.assign({}, this.bindForm))
                                this.setModalShow(false)
                            }
                            // 2010-03-21 批量审核加入的专有属性
                            else if (this.attrs.isBatchAudit) {
                                // 将提交的数据和url发送出去
                                this.$eventHub.$emit(this.$events.BATCH_AUDIT_SUBMIT_DATA, {
                                    url: url,
                                    method: this.attrs.method,
                                    data: this.bindForm
                                })
                                this.setModalShow(false)
                            } else {
                                if(this.attrs.hasOwnProperty('idname')) {
                                    this.$set(this.bindForm, this.attrs.idname, this.$route.params.id)
                                }
                                this.submit(url, this.submit)
                            }
                        }
                    })
                }
                // if (!this.doValidate()) return false

            },
            /**
             * 列表中的弹窗删除
             */
            handleDelete() {
                this.$Modal.confirm({
                    title: '操作确认',
                    content: '<p>素材删除后不可恢复，确认删除选中素材吗？</p>',
                    onOk: () => {
                        this.doDelete()
                    }
                })                
            },
            doDelete() {
                this.$api['DELETE'](this.attrs.delApi + '/'+ this.row.id).then((rs) => {
                    this.setModalShow(false)
                    this.$Message.success('删除成功')
                    // 刷新当前页面
                    if (this.attrs.route && this.attrs.route == ':rf') {
                        location.reload()
                    } else {
                        // 表单重置
                        this.$refs['lyForm'].resetFields();
                        // 重置表单选中数据
                        this.tableSelectLists = []
                        // 发送刷新页面数据的事件
                        this.$eventHub.$emit(this.$events.REFRESH_SEARCH_DATA)
                    }
                }).catch((err) => {
                    this.setModalShow(false)
                    console.error(err)
                    this.$Message.error({content: err, duration: 5 })
                })
            },
            keyDownEvent () {
            },
            /**
            * 提取提交数据 wxq 2019.2.25
            */
            submit (url, callback) {
                // 进行数据的提交
                this.$api[this.attrs.method](url, this.bindForm).then((rs) => {
                    this.setModalShow(false)
                    this.bindForm = {}
                    this.$Message.success('提交成功')
                    // 刷新当前页面
                    if (this.attrs.route && this.attrs.route == ':rf') {
                        location.reload()
                    } else {
                        // 表单重置
                        this.$refs['lyForm'].resetFields();
                        // 重置表单选中数据
                        this.tableSelectLists = []
                        // 发送刷新页面数据的事件
                        this.$eventHub.$emit(this.$events.REFRESH_SEARCH_DATA)
                    }
                    // 如果是审核通过或者拒绝成功 关闭当前页面 updata 2019.2.22 wxq
                    clearInterval(this.interval)
                    if (url == "api/admin/essaypass" || url == "api/admin/essaydeny") {
                        let t
                        clearTimeout(t)
                        t = setTimeout(() => {
                            window.opener=null;
                            window.open('','_self');
                            window.close();
                        }, 1000)
                    }
                }).catch((err) => {
                    this.setModalShow(false)
                    console.error(err)
                    this.$Message.error({content: err, duration: 5 })
                    clearInterval(this.interval)
                    if ((url == "api/admin/essaypass" || url == "api/admin/essaydeny") && callback && err == 'Network Error') {
                        this.interval = setInterval(() => {
                            callback(url, callback)
                        }, 5000)
                    }
                })
            }
        }
    }
</script>
<style>
    .ly-dialog-button {
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/dialog-button/src/index.vue